import React, { Component } from "react";
import { HALLOWEEN_URL, trackHalloween } from "./api";

// Passing the page on. Phones get their own share sheet; everyone gets the
// usual places and a copy button. The link is the page, never a code: codes
// are one each.

const TEXT = "Trick or treat? Spin the 42courses pumpkin wheel for a spooky discount, or let the witch read your mind.";

// Single-colour icons, so they take the chip's colour. WhatsApp, X and email
// are the ones on the referral page.
const Icon = ({ children, stroke }: { children: React.ReactNode; stroke?: boolean }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill={stroke ? "none" : "currentColor"}
    stroke={stroke ? "currentColor" : undefined}
    strokeWidth={stroke ? 2 : undefined}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

const PLACES = [
  {
    name: "WhatsApp",
    href: () => `https://wa.me/?text=${encodeURIComponent(`${TEXT} ${HALLOWEEN_URL}`)}`,
    icon: (
      <Icon>
        <path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.73 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zM12.05 20.15h-.01a8.22 8.22 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.19-.31a8.22 8.22 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.83c-.01 4.54-3.71 8.23-8.25 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.37-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.05s.88 2.38 1.01 2.54c.12.17 1.74 2.66 4.22 3.73.59.25 1.05.4 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.23-.18-.48-.3z" />
      </Icon>
    ),
  },
  {
    name: "LinkedIn",
    href: () => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(HALLOWEEN_URL)}`,
    icon: (
      <Icon>
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45z" />
      </Icon>
    ),
  },
  {
    name: "X",
    href: () => `https://twitter.com/intent/tweet?text=${encodeURIComponent(TEXT)}&url=${encodeURIComponent(HALLOWEEN_URL)}`,
    icon: (
      <Icon>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </Icon>
    ),
  },
  {
    name: "Facebook",
    href: () => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(HALLOWEEN_URL)}`,
    icon: (
      <Icon>
        <path d="M13.6 21.5v-8.2h2.75l.41-3.2H13.6V8.06c0-.93.26-1.56 1.59-1.56h1.7V3.64c-.3-.04-1.3-.13-2.47-.13-2.45 0-4.12 1.49-4.12 4.23v2.36H7.53v3.2h2.77v8.2h3.3z" />
      </Icon>
    ),
  },
  {
    name: "Email",
    href: () => `mailto:?subject=${encodeURIComponent("Trick or treat?")}&body=${encodeURIComponent(`${TEXT}\n\n${HALLOWEEN_URL}`)}`,
    icon: (
      <Icon stroke>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 7l9 6 9-6" />
      </Icon>
    ),
  },
];

const LinkIcon = () => (
  <Icon stroke>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </Icon>
);

interface State {
  copied: boolean;
}

class Share extends Component<{ heading?: string }, State> {
  state: State = { copied: false };
  private copiedTimer?: number;

  componentWillUnmount() {
    window.clearTimeout(this.copiedTimer);
  }

  canShareNatively = () => typeof navigator !== "undefined" && typeof (navigator as any).share === "function";

  shareNatively = () => {
    trackHalloween("share", { place: "device" });
    (navigator as any).share({ title: "Trick or treat?", text: TEXT, url: HALLOWEEN_URL }).catch(() => {
      // Closing the share sheet is not an error worth showing.
    });
  };

  copy = () => {
    trackHalloween("share", { place: "copy" });
    const done = () => {
      this.setState({ copied: true });
      window.clearTimeout(this.copiedTimer);
      this.copiedTimer = window.setTimeout(() => this.setState({ copied: false }), 2500);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(HALLOWEEN_URL).then(done).catch(() => window.prompt("Copy this link", HALLOWEEN_URL));
    } else {
      window.prompt("Copy this link", HALLOWEEN_URL);
    }
  };

  render() {
    return (
      <div className="hw-share">
        <p className="hw-share__heading">{this.props.heading || "Share the fright"}</p>
        <div className="hw-share__buttons">
          {this.canShareNatively() && (
            <button type="button" className="hw-chip hw-chip--strong" onClick={this.shareNatively}>
              Share
            </button>
          )}
          {PLACES.map((place) => (
            <a
              key={place.name}
              className="hw-chip hw-chip--icon"
              href={place.href()}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={place.name}
              title={place.name}
              onClick={() => trackHalloween("share", { place: place.name.toLowerCase() })}
            >
              {place.icon}
            </a>
          ))}
          <button
            type="button"
            className="hw-chip hw-chip--icon"
            aria-label="Copy link"
            title="Copy link"
            onClick={this.copy}
          >
            <LinkIcon />
            {this.state.copied && <span>Copied</span>}
          </button>
        </div>
      </div>
    );
  }
}

export default Share;
